{
  "pull": "Tirez vers le bas pour rafraîchir la page...",
  "release": "Relâcher pour recharger...",
  "filters-search": "Rechercher...",
  "filters-all": "Tous",
  "filters-none": "Aucun",
  "filters-cancel": "Annuler",
  "filters-ok": "OK",
  "filters-no-match": "Aucun résultat ne correspond aux critères.",
  "filters-no-options": "Aucun choix disponible.",
  "reload": "Recharger",
  "logout": "Quitter",
  "good-morning": "Bonjour",
  "good-afternoon": "Bonjour",
  "good-evening": "Bonjour",
  "date-picker-cancel": "Annuler",
  "date-picker-ok": "OK",
  "date-picker-label": "Choisir la date et l’heure",
  "collapse-sidebar": "Fermer le panneau de navigation",
  "expand-sidebar": "Ouvrir le panneau de navigation",
  "algo-fill": "FR Algorithmic Fill",
  "na": "FR N/A",
  "table-rows-select": "de rangées",
  "table-rows-displayed": "{from}-{to} de {count}",
  "table-first-page": "1e page",
  "table-last-page": "Dernière page",
  "table-next-page": "Page suivante",
  "table-previous-page": "Page précédente",
  "tableRowsDisplayed": "{from}-{to} de {count}",
  "tableClearSearchAriaLabel": "Supprimer la recherche",
  "tableFirstPage": "Première page",
  "tableLastPage": "Dernière page",
  "tableNextPage": "Page suivante",
  "tablePreviousPage": "Page précédente",
  "labelRows": "allées",
  "tableSearchTooltip": "Chercher",
  "tableSearchPlaceholder": "Chercher",
  "tableSearchAriaLabel": "Chercher",
  "tableSearch": "Rechercher...",
  "tableRowsPerPage": "Lignes par page :",
  "sortBy": "TRIER PAR",
  "showFiltersAndSorting": "Afficher les filtres et le tri",
  "hideFiltersAndSorting": "Masquer les filtres et le tri",
  "searchPlaceholder": "Rechercher par {{searchKeys}}",
  "all": "Tous",
  "noRecords": "Aucun enregistrement à afficher",
  "listTable": {
    "filters": "Filtres",
    "columns": "Colonnes",
    "drawers": {
      "columns": {
        "title": "Colonnes",
        "columns": {
          "show": "Afficher",
          "columnName": "Nom de colonne"
        }
      },
      "filters": {
        "title": "Filtres"
      },
      "buttons": {
        "cancel": "Fermer",
        "restoreDefaults": "Restaurer les paramètres par défaut",
        "apply": "Appliquer"
      }
    }
  }
}
